export default "__VITE_ASSET__Ff$y$ENS__"